import { InnerLayout } from '../style/Layout';
import React from 'react'
import ReviewItem from './ReviewItem';
import Title from './Title';
import styled from 'styled-components'

function ReviewSection() {
    return (
        // <InnerLayout>
            <ReviewSectionStyled>
                <Title title={"Reviews"} span={"Reviews"} />
                <InnerLayout>
                    <div className="reviews">
                        <ReviewItem 
                            text={"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Autem esse perspiciatis inventore?"} />
                        <ReviewItem 
                            text={"Lorem ipsum dolor sit amet consectetur, adipisicing elit. Autem esse perspiciatis inventore?"} />
                    </div>
                </InnerLayout>
            </ReviewSectionStyled>
        // </InnerLayout>
    )
}

const ReviewSectionStyled = styled.section`
    .reviews {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 1.5rem;
        width: 100%;
    }
    @media only screen and (max-width: 650px) {
        .reviews {
            grid-template-columns: 1fr;
        }
    }
    `;

export default ReviewSection
